import { Component, OnInit, ViewChild } from '@angular/core'
import { SeFeDomainEnvironmentService } from 'se-fe-domain-environment'
import { AnalyticsService } from '@se-po/shared-data-access-services'

@Component({
  selector: 'se-po-household-setup-already-have-account',
  templateUrl: './already-have-account.component.html',
  styleUrls: ['./already-have-account.component.scss'],
  standalone: false,
})
export class AlreadyHaveAccountComponent implements OnInit {

  @ViewChild('signInForm') public signInForm: HTMLFormElement

  public actionUrl: string
  public signingIn = false

  constructor(
    private analyticsService: AnalyticsService,
    private env: SeFeDomainEnvironmentService,
  ) { }

  public ngOnInit(): void {
    this.actionUrl = `${this.env.getUrl('userService')}users/not_you`
  }

  public signIn(): void {
    this.signingIn = true
    this.analyticsService.seEvent('AlreadyHaveAccountClick')
    this.signInForm.nativeElement.submit()
  }
}
